import type { ReactNode } from 'react';
import { AccountHeader } from '@/components/layouts/AccountHeader';
import { useUser } from '@/hooks/use-user';

export function AccountEventsLayout({ children }: { children: ReactNode }) {
  const { user } = useUser();

  return (
    <div className="min-h-screen bg-background">
      <AccountHeader user={user} />
      <main className="mx-auto max-w-3xl px-4 py-8">{children}</main>
    </div>
  );
}
